angular.module('app.financeiro').factory('liquidacaoAutomaticaFactory', ['$http', 'SweetAlert', function ($http, SweetAlert) {

    var _apiName = 'Boleto';

    var _listaLiquidacao = function (search, options, dataInicio, dataTermino, situacao) {

        var dto = options.data;

        dto.search = search;

        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaLiquidacoes', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            SweetAlert.swal({
                title: "",
                text: response.data.Messages[0].Description,
                showCancelButton: false,
                confirmButtonText: "OK",
                closeOnConfirm: true
            });
        });
    };

    var factory = {};

    factory.listaLiquidacao = _listaLiquidacao;

    return factory;

}]);
